<script setup>
import { ref } from 'vue'
import BlockContent from '../UI/Content/BlockContent.vue'
import FieldCreator from '../UI/Form/FieldCreator.vue'
import FormCreator from '../UI/Form/FormCreator.vue'
import useApi from '../../Composables/useApi'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const { getJSON } = useApi()

const emit = defineEmits(['siren-changed', 'eligibility-checked', 'eligibility-error'])

const formData = ref({})
const loadField = ref(false)
const waiting = ref(false)

const updateData = (newData) => {
  formData.value = newData
}

const setSirenClient = (val) => {
  emit('siren-changed', val)
}

const setBuild = (bool) => {
  loadField.value = bool
}

const isSending = (bool) => {
  waiting.value = bool
}

const setDatas = (json) => {
  emit('eligibility-checked', {
    name: json.name,
    isEligible: json.isEligible,
  })
}

const setErrors = () => {
  emit('eligibility-error', t('home.dashboardQuotation.modal.erreurMessage'))
}
</script>

<template>
  <BlockContent
    class="fs-16"
    title-t="home.dashboardQuotation.title"
    title-level="5"
    color="info"
    e2e-block="homeDashboardQuotation"
  >
    <FieldCreator
      type-value="string"
      :form-data="formData"
      v-if="loadField"
      name="sirenClient"
      form-ref="myelibility"
      domain="eligibility"
      label-top
      dynamic-label
      @get-select-change="setSirenClient"
    />
    <div class="invalid-feedback-sirenClient is-invalid"></div>
    <div class="d-flex justify-content-center">
      <FormCreator
        @update-data="updateData"
        ref="myelibility"
        endpoint="eligibilities"
        method="post"
        :params="{ e: 0 }"
        @form-build="setBuild"
        @form-return="setDatas"
        @form-error="setErrors"
        @is-sending="isSending"
      >
        <span e2e-button="testEligibility">{{ $t('button.test') }}</span>
      </FormCreator>
    </div>
  </BlockContent>
</template>
